import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchAllMemberships = createAsyncThunk(
  "membership/fetchAll",
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const response = await axios.get(
        `${server}/membership/GetAllMembership`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchMembershipById = createAsyncThunk(
  "membership/fetchById",
  async (id, thunkAPI) => {
    try {
      const token = localStorage.getItem("authToken");

      if (!token) {
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const response = await axios.get(
        `${server}/membership/GetMembershipById`,
        {
          headers: {
            Authorization: token,
          },
          params: { id },
        }
      );

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const membershipSlice = createSlice({
  name: "membership",
  initialState: {
    allMemberships: [],
    selectedMembership: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedMembership: (state) => {
      state.selectedMembership = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // All Memberships
      .addCase(fetchAllMemberships.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMemberships.fulfilled, (state, action) => {
        state.loading = false;
        state.allMemberships = action.payload;
      })
      .addCase(fetchAllMemberships.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Membership By ID
      .addCase(fetchMembershipById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMembershipById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedMembership = action.payload;
      })
      .addCase(fetchMembershipById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSelectedMembership } = membershipSlice.actions;
export default membershipSlice.reducer;
